import React from 'react';
import SquadManager from '../SquadManager';

/**
 * Embedded squads manager for the coach Team Management dashboard.
 * Wraps SquadManager in "embedded" variant so it renders inline instead of as a modal.
 */
export default function SquadsPanel({ team, onChanged }) {
  if (!team) {
    return <p className="text-gray-500 text-sm">Select a team to manage squads.</p>;
  }

  return (
    <div className="bg-white p-4 rounded-lg shadow">
      <SquadManager team={team} variant="embedded" onChanged={onChanged} />
    </div>
  );
}
